export default "__VITE_ASSET__813c0018__"